import ApiClient from './ApiClient';

// Teletel independent SLA endpoints (fail-closed while TELETEL_SLA_ENABLED is
// off). The stock enterprise route stays defined and untouched; only this
// client was repointed, per the approved clean-room pattern.
class SlaAPI extends ApiClient {
  constructor() {
    super('teletel/sla_policies', { accountScoped: true });
  }
}

export default new SlaAPI();
